import axios from 'axios';
import { isProductionEnv } from '@/assets/js/utils';
import { ERR_OK, STATUS_NO_DATA, STATUS_ERROR, STATUS_LOADED, STATUS_LOADING } from '@/assets/js/configs';


export default {
  data() {
    // Note that property names starting with '$' or '_' of 'data' WILL NOT be proxied by Vue!
    // So we have to access them by vm.$data.xxx(e.g., vm.$data.$_nestedSpinnerMixin_loading)!
    return {
      $_nestedSpinnerMixin_status: STATUS_LOADING,
    };
  },
  methods: {
    async $_nestedSpinnerMixin_fetchData(apiFn, resolve, reject, statusKey) {
      const setStatus = this.$_nestedSpinnerMixin_getSetStatusFn(statusKey);
      setStatus(STATUS_LOADING);
      let response;
      try {
        response = await apiFn();
      } catch (e) {
        if (axios.isCancel(e)) {
          if (!isProductionEnv()) console.log(e.message);
          return;
        }
        ({ response } = e);
        if (!response) {
          console.error('Error', e.message);
        }
      }
      if (response) {
        const { status, data } = response;
        if (status === ERR_OK) {
          if (this.$_nestedSpinnerMixin_checkEmptyRes(data)) {
            setStatus(STATUS_NO_DATA);
          } else {
            setStatus(STATUS_LOADED);
            resolve(data);
          }
        } else {
          setStatus(STATUS_ERROR);
          const { message } = data;
          if (message) {
            console.error(message);
          }
          if (reject) {
            reject(data);
          }
        }
      } else {
        setStatus(STATUS_ERROR);
      }
    },
    $_nestedSpinnerMixin_getSetStatusFn(statusKey) {
      switch (typeof statusKey) {
        case 'string':
          return (status) => {
            this[statusKey] = status;
          };
        case 'object': {
          let targetObj = this;
          let targetKey;
          const parseKey = (obj) => {
            const keys = Object.keys(obj);
            if (keys.length > 1) {
              throw new Error('invalid statusKey');
            }
            const key = keys[0];
            targetObj = targetObj[key];
            const value = obj[key];
            const valueType = typeof value;
            if (valueType === 'string') {
              targetKey = value;
            } else if (valueType === 'object') {
              parseKey(value);
            } else {
              throw new Error('invalid statusKey');
            }
          };
          parseKey(statusKey);
          return (status) => {
            targetObj[targetKey] = status;
          };
        }
        case 'undefined':
          return (status) => {
            this.$data.$_nestedSpinnerMixin_status = status;
          };
        default:
          throw new Error('invalid statusKey');
      }
    },
    $_nestedSpinnerMixin_checkEmptyRes(data) {
      return Array.isArray(data) && data.length === 0;
    },
  },
};
